import {
  EntertainmentVideoStatus,
  FullEntertainmentVideo
} from 'modules/entertainment-videos/types';

type FieldName = 'countries' | 'status' | 'video' | 'audio' | 'timeframe';

export function getInvalidFields(
  fullEntertainmentVideo: FullEntertainmentVideo
): Array<FieldName> {
  const {
    entertainmentVideo: {
      publishedCountries,
      status,
      audioType,
      publishedFrom,
      publishedUntil
    },
    media
  } = fullEntertainmentVideo;

  const isPublishedCountriesValid = Array.isArray(publishedCountries) && publishedCountries.length > 0;
  const isInPublishableStatus =
    status === EntertainmentVideoStatus.PENDING ||
    status === EntertainmentVideoStatus.PUBLISH_FAILED ||
    status === EntertainmentVideoStatus.UNPUBLISHED;
  const isVideoValid = !!media?.url;
  const isAudioTypeValid = !!audioType;

  const isTimeframeValid = publishedFrom != null && publishedUntil != null && Date.parse(publishedFrom) < Date.parse(publishedUntil);
  const invalidFields: Array<FieldName> = [];

  if (!isPublishedCountriesValid) {
    invalidFields.push('countries');
  }

  if (!isInPublishableStatus) {
    invalidFields.push('status');
  }

  if (!isVideoValid) {
    invalidFields.push('video');
  }

  if (!isAudioTypeValid) {
    invalidFields.push('audio');
  }

  if (!isTimeframeValid) {
    invalidFields.push('timeframe');
  }

  return invalidFields;
}
